import AppRoutePath from "../../../router/AppRoutePath";
import { Button } from "react-bootstrap";
import { NavLink } from "react-router-dom";
import moment from "moment";

export const dataBreadcrumb = [
  { label: "Daftar Nasabah", route: AppRoutePath.CUSTOMER },
  { label: "Detail Nasabah", route: null },
];

export const initLoanHistoryFilter = {
  page: 1,
  pageSize: 10,
  sortingField: null,
  sortingOrder: null,
};

export const initDataMembershipFilter = {
  startDate: null,
  endDate: null,
};

export const dateFilterMembership = [
  {
    label: "Semua",
    key: "all",
    value: { startDate: null, endDate: null },
  },
  {
    label: "Tahun Ini",
    key: "yearly",
    value: {
      startDate: moment().startOf("year").format(),
      endDate: moment().endOf("year").format(),
    },
  },
  {
    label: "Bulan Ini",
    key: "monthly",
    value: {
      startDate: moment().startOf("month").format(),
      endDate: moment().endOf("month").format(),
    },
  },
  {
    label: "Minggu Ini",
    key: "weekly",
    value: {
      startDate: moment().startOf("week").format(),
      endDate: moment().endOf("week").format(),
    },
  },
  {
    label: "Hari Ini",
    key: "daily",
    value: {
      startDate: moment().startOf("day").format(),
      endDate: moment().endOf("day").format(),
    },
  },
];

export const loanHistoryColumn = [
  {
    dataIndex: "dateTime",
    key: "dateTime",
    backend_key: "gadai_at",
    title: "Tanggal & Waktu",
    sorter: true,
    width: "10%",
  },
  {
    dataIndex: "sbg",
    key: "sbg",
    title: "No. SBG",
  },
  {
    dataIndex: "paymentType",
    key: "paymentType",
    title: "Jenis Pembayaran",
  },
  {
    dataIndex: "gadaiItem",
    key: "gadaiItem",
    title: "Barang Jaminan",
  },
  {
    dataIndex: "loanValue",
    key: "loanValue",
    title: "Nilai Pinjaman",
  },
  {
    dataIndex: "loanMethod",
    key: "loanMethod",
    title: "Metode Pinjaman",
  },
  {
    dataIndex: "status",
    key: "status",
    title: "Status",
    render: (_, record) => (
      <p
        style={{
          color: record.status.color,
        }}
      >
        {record.status.label}
      </p>
    ),
  },
  {
    dataIndex: "action",
    key: "action",
    title: "Aksi",
    width: "10%",
    render: (_, record) => (
      <div style={{ textAlign: "center", display: "grid" }}>
        <NavLink to={`/report/pawn/${record.id}`}>
          <Button variant="primary" className="btn-action btn-detail">
            Detail
          </Button>
        </NavLink>
      </div>
    ),
  },
];
